import { Api } from "laravel-request";
import {
    responseOnLaravelRequestException,
    responseOnLaravelRequestSuccess,
} from "#app/api/types/responseTypes";

export const getEmployees = (
    callbackOnSuccess: (response: responseOnLaravelRequestSuccess) => any,
    callbackOnError?: (xhr: XMLHttpRequest, responseData: unknown) => any
) => {
    return Api.get("employee", "index")
        .whereHas("roles", (query: any) => query.where("slug", "manager").orWhere("slug", "owner"))
        .all(
            (response) => callbackOnSuccess && callbackOnSuccess(response),
            (error: XMLHttpRequest, responseData: unknown) =>
                callbackOnError && callbackOnError(error, responseData)
        );
};

export const bindClient = (
    accountsToBind: any[],
    queryParamsList: any,
    shareUser: boolean = false
) => {
    const boundClientsList = (list: any, entryToAdd: any[]) => ({
        ...list,
        ...{ services: entryToAdd },
    });
    return Api.post(
        "client",
        "bind",
        accountsToBind.length > 0
            ? boundClientsList(queryParamsList, accountsToBind)
            : queryParamsList
    );
};
